import { render, staticRenderFns } from "./FieldsetFavoritePlayerParts.vue?vue&type=template&id=68e88936&scoped=true"
import script from "./FieldsetFavoritePlayerParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetFavoritePlayerParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetFavoritePlayerParts.vue?vue&type=style&index=0&id=68e88936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e88936",
  null
  
)

export default component.exports